import React from "react";
import "./VideoBlock.css";

import { FiZap, FiDollarSign, FiTarget, FiTrendingUp } from "react-icons/fi";
import { BsMegaphone } from "react-icons/bs";
import { HiOutlineLightBulb } from "react-icons/hi";

function VideoBlock() {
  const wheelItems = [
    {
      label: "Fast Execution",
      icon: <FiZap />,
      percent: 15,
      angle: 30,
      description:
        "We move quickly from planning to launch, reducing delays and keeping campaigns on track without sacrificing quality.",
    },
    {
      label: "Cost Effective",
      icon: <FiDollarSign />,
      percent: 20,
      angle: 90,
      description:
        "Our approach focuses on efficient media, creative, and execution so your budget works harder and waste stays low.",
    },
    {
      label: "Strategy First",
      icon: <FiTarget />,
      percent: 20,
      angle: 150,
      description:
        "Every decision starts with your business goals, audience insights, and channel strategy to create smarter growth.",
    },
    {
      label: "Brand Awareness",
      icon: <BsMegaphone />,
      percent: 15,
      angle: 210,
      description:
        "We help more of the right people discover, remember, and trust your brand through consistent and effective messaging.",
    },
    {
      label: "Higher ROI",
      icon: <FiTrendingUp />,
      percent: 20,
      angle: 270,
      description:
        "Campaigns are designed to improve returns by focusing on measurable performance, conversion quality, and optimization.",
    },
    {
      label: "Content Focused",
      icon: <HiOutlineLightBulb />,
      percent: 10,
      angle: 330,
      description:
        "We create content that is built for attention, engagement, and action across ads, social, landing pages, and funnels.",
    },
  ];

  return (
    <section className="video-pro">
      <div className="video-pro__shell">
        <div className="video-pro__inner">
          <div className="video-pro__copy">
            <span className="video-pro__eyebrow">Show, don’t tell</span>

            <h2>Our strategy that helps brands grow</h2>

            <p>
              Clear strategy. Smart execution. Strong creative. We focus on what
              actually moves your brand forward.
            </p>

            <ul className="video-pro__highlights">
              <li>
                <strong>Strategy-first</strong> planning
              </li>
              <li>
                <strong>Fast execution</strong> without chaos
              </li>
              <li>
                <strong>Conversion-focused</strong> creative
              </li>
            </ul>

            <a className="video-pro__ctaPrimary" href="/contact">
              Get a free proposal
            </a>
          </div>

          <div className="video-pro__card">
            <div className="strategyWheel" aria-label="Strategy wheel">
              <div className="strategyWheel__bg" />

              <div className="wheelCenter">
                <span>Shyne</span>
                <small>Strategy</small>
              </div>

              {wheelItems.map((item) => (
                <div
                  key={item.label}
                  className="wheelItem"
                  style={{ "--angle": `${item.angle}deg` }}
                >
                  <div
                    className="wheelItem__content"
                    tabIndex="0"
                    role="button"
                    aria-label={`${item.label}: ${item.description}`}
                  >
                    <span className="wheelIcon">{item.icon}</span>
                    <p>{item.label}</p>
                    <small className="wheelPercent">{item.percent}%</small>

                    <div className="wheelTooltip" role="tooltip">
                      <strong>{item.label}</strong>
                      <span>{item.description}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default VideoBlock;